import { Component, effect, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SseNotificationStore } from '../../../stores/sse-notification/sse-notification.store';
import { UserStore } from '../../../stores/user.store';

/**
 * 헤더 컴포넌트
 * @description 메인 레이아웃의 상단 헤더를 담당
 * @author 정정용 <jeongyong@lepisode.team>
 */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  imports: [RouterLink, RouterLinkActive],
})
export class HeaderComponent {
  protected readonly userStore = inject(UserStore);
  protected readonly notificationStore = inject(SseNotificationStore);

  constructor() {
    // 사용자 로그인 상태 변경 시 알림 카운트 가져오기
    effect(() => {
      if (this.userStore.user()) {
        this.notificationStore.fetchState();
      }
    });
  }
}
